import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Camera, 
  Activity, 
  Users,
  Upload,
  BarChart3,
  Plug,
  Radio,
  Settings,
  FileText,
  DollarSign,
  Shield,
  Book,
  Key
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/cameras', icon: Camera, label: 'Cameras' },
  { to: '/radio', icon: Radio, label: 'Radio' },
  { to: '/sessions', icon: Activity, label: 'Sessions' },
  { to: '/users', icon: Users, label: 'Users' },
  { to: '/analytics', icon: BarChart3, label: 'Analytics' },
  { to: '/ads', icon: DollarSign, label: 'Ads' },
  { to: '/integrations', icon: Plug, label: 'Integrations' },
  { to: '/assets', icon: Upload, label: 'Assets' },
  { to: '/security', icon: Shield, label: 'Security' },
  { to: '/api-keys', icon: Key, label: 'API Keys' },
  { to: '/api-docs', icon: Book, label: 'API Docs' },
  { to: '/settings', icon: Settings, label: 'Settings' },
  { to: '/audit-log', icon: FileText, label: 'Audit Log' },
];

export function Sidebar() {
  return (
    <aside 
      className="fixed left-0 top-0 z-40 h-screen w-64 border-r border-border bg-card"
      data-testid="sidebar"
    >
      <div className="flex h-full flex-col">
        {/* Logo */}
        <div className="flex h-16 items-center gap-3 border-b border-border px-6">
          <img 
            src="/railstream-logo-transparent.png" 
            alt="RailStream" 
            className="h-10 w-auto"
          />
          <div>
            <h1 className="text-lg font-bold tracking-tight text-white">RailStream</h1>
            <p className="text-xs text-white/70">Tower Admin</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1 p-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                )
              }
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="border-t border-border p-4">
          <p className="text-xs text-white/60 text-center">
            © Orange Cat Studios
          </p>
          <p className="text-xs text-white/60 text-center">
            RailStream Tower
          </p>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
